angular.module('app').factory('casinoCategoryService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer)
        {
            Configurer.setBaseUrl(settings.apiURL);
        });

        restAngular = restAngular.all("/CasinoCategory/");

        return {
            create: function (requestData) {
                return restAngular.
                    one("create").
                    post("", requestData)
            },
            get: function (requestData) {
                return restAngular.
                    one("get").
                    customGET(param(requestData))
            },
            edit: function (requestData) {
                return restAngular.
                    one("change").
                    post("", requestData)
            }
        }
    }
]);